"use client";

import type { ReactNode } from "react";
import { useCommand } from "../Context";

export function RenderCommandDialogs({ children }: { children: ReactNode }) {
	const { open, activeDialog } = useCommand();

	if (open || activeDialog !== undefined) {
		return children;
	}

	return null;
}
